export const MediaTypeOptions = {
  IMAGE: "image",
  VIDEO: "video"
};
export const MediaTypeIconClasses = {
  [MediaTypeOptions.IMAGE]: "far fa-images fa-fw",
  [MediaTypeOptions.VIDEO]: "far fa-video fa-fw"
};
export const MediaTypeLabels = {
  [MediaTypeOptions.IMAGE]: "Image",
  [MediaTypeOptions.VIDEO]: "Video"
};
